import type { BrandColors } from '@packages/design-tokens';
import { createSelector as createSelectorNative } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import { createSelector, selector } from '@/store/utils';
import { mapOrganizationBrandingToBrandColors } from '@/utils/color';

const selectTenant = selector((state) => state.configuration.tenant);
export const tenantSelector = createSelector(selectTenant);

const selectConsents = selector((state) => state.configuration.consents);
export const consentsSelector = createSelector(selectConsents);

const selectSalesPointConfiguration = selector(
  (state) => state.configuration.salesPointConfiguration
);
export const salesPointConfigurationSelector = createSelector(
  selectSalesPointConfiguration
);

const selectSalesPointPaymentTypes = selector(
  (state) => state.configuration.salesPointPaymentTypes
);
export const salesPointPaymentTypesSelector = createSelector(
  selectSalesPointPaymentTypes
);

const selectCountries = selector((state) => state.configuration.countries);
export const countriesSelector = createSelector(selectCountries);

export const brandColorsSelector = createSelectorNative(
  salesPointConfigurationSelector,
  tenantSelector,
  (salesPointConfiguration, tenant) =>
    mapOrganizationBrandingToBrandColors(
      salesPointConfiguration?.organizationBranding,
      tenant.value
    )
) as (state: RootState) => BrandColors;
